module.exports = __webpack_public_path__ + "static/img/s38.70ee8c81.png";